interface SoundExtraData {
  arrows: string;
  lines: string;
  lineYOffset?: number;
  hasTail: boolean;
}

type SoundName =
  | 'a'
  | 'b'
  | 'c'
  | 'd'
  | 'e'
  | 'f'
  | 'g'
  | 'h'
  | 'i'
  | 'j'
  | 'k'
  | 'l'
  | 'm'
  | 'n'
  | 'o'
  | 'p'
  | 'r'
  | 's'
  | 't'
  | 'u'
  | 'v'
  | 'w'
  | 'x'
  | 'y'
  | 'z'
  | 'ck'
  | 'qu'
  | 'sh'
  | 'ch'
  | 'th'
  | 'ng'
  | 'ai'
  | 'ee'
  | 'ie'
  | 'oa'
  | 'ue'
  | 'ar'
  | 'er'
  | 'or'
  | 'oi'
  | 'ou'
  | 'oo'
  | 'air'
  | 'ear'
  | 'ure';

const soundsExtraData: Record<SoundName, SoundExtraData> = {
  s: {
    arrows:
      'm 32.351338,17.578787 -1.051009,-0.404352 -0.118145,0.279524 -0.759644,-0.770431 1.110394,-0.06882 -0.118146,0.279525 1.0547,0.405029 z',
    lines: 'M 12.459563,38.58273 H 40.608185',
    lineYOffset: 4,
    hasTail: false,
  },
  a: {
    arrows:
      'm 31.150811,17.121945 -1.491231,-0.413661 -0.108829,0.463884 -1.164357,-1.049967 1.48573,-0.341978 -0.108831,0.463884 1.496337,0.413947 z',
    lines: 'M 12.452679,36.654907 H 40.601301',
    lineYOffset: 14,
    hasTail: false,
  },
  t: {
    arrows:
      'm 24.617329,13.876062 0.01929,1.125942 0.303431,0.0047 -0.429338,0.993123 -0.480204,-1.00355 0.303431,0.0047 -0.02005,-1.12962 z',
    lines: 'M 12.447152,40.565075 H 40.595774',
    lineYOffset: 3,
    hasTail: false,
  },
  p: {
    arrows:
      'm 18.704943,9.2857338 0.193599,1.1093422 0.300491,-0.04239 -0.270196,1.047673 -0.629967,-0.916979 0.300491,-0.04239 -0.194919,-1.1128577 z',
    lines: 'M 12.442653,31.192604 H 40.591275',
    lineYOffset: 3,
    hasTail: true,
  },
  i: {
    arrows:
      'm 24.64532,21.08123 0.0085,1.126077 0.30337,0.0076 -0.43885,0.988956 -0.470549,-1.008113 0.303371,0.0076 -0.0092,-1.129761 z',
    lines: 'M 12.434001,42.672311 H 40.582623',
    lineYOffset: 3,
    hasTail: false,
  },
  n: {
    arrows:
      'm 17.380499,16.414227 0.237354,1.100811 0.298574,-0.05426 -0.228535,1.057542 -0.665752,-0.891337 0.298576,-0.05426 -0.238788,-1.104276 z',
    lines: 'M 12.420901,37.977665 H 40.569523',
    lineYOffset: 3,
    hasTail: false,
  },
  c: {
    arrows:
      'm 32.974044,17.187567 -1.089667,-0.284152 -0.08611,0.290994 -0.841117,-0.680548 1.095708,-0.192698 -0.08611,0.290994 1.093413,0.284411 z',
    lines: 'M 12.400366,38.510622 H 40.548988',
    lineYOffset: 3,
    hasTail: false,
  },
  e: {
    arrows:
      'm 19.004524,26.975624 1.12563,-0.03281 0.0011,-0.303465 0.998207,0.417379 -0.99771,0.492223 0.0011,-0.303466 -1.129298,0.03361 z',
    lines: 'M 12.478941,38.497423 H 40.627563',
    lineYOffset: 3,
    hasTail: false,
  },
  h: {
    arrows:
      'm 17.517908,10.263183 0.01929,1.125942 0.303431,0.0047 -0.429338,0.993123 -0.480204,-1.00355 0.303431,0.0047 -0.02005,-1.12962 z',
    lines: 'M 12.589877,44.263552 H 40.738499',
    lineYOffset: 3,
    hasTail: false,
  },
  r: {
    arrows:
      'm 22.146641,16.532271 0.146561,1.116529 0.302015,-0.02966 -0.314214,1.035323 -0.590667,-0.942773 0.302014,-0.02966 -0.147732,-1.120098 z',
    lines: 'M 12.44192,38.110314 H 40.590542',
    lineYOffset: 3,
    hasTail: false,
  },
  m: {
    arrows:
      'm 11.563301,16.532271 0.146561,1.116529 0.302015,-0.02966 -0.314214,1.035323 -0.590667,-0.942773 0.302014,-0.02966 -0.147732,-1.120098 z',
    lines: 'M 5.2949137,37.955427 H 47.81063',
    lineYOffset: 3,
    hasTail: false,
  },
  d: {
    arrows:
      'm 32.212069,24.148724 -1.053563,-0.397647 -0.116362,0.280272 -0.764537,-0.765576 1.109931,-0.0759 -0.116361,0.280272 1.057262,0.398297 z',
    lines: 'M 12.447152,44.798411 H 40.595774',
    lineYOffset: 3,
    hasTail: false,
  },
  g: {
    arrows:
      'm 33.849127,9.769048 -1.093339,-0.2696792 -0.08225,0.2921101 -0.850066,-0.6693364 1.093056,-0.2072107 -0.08224,0.29211 1.09709,0.2698852 z',
    lines: 'M 12.257645,31.096154 H 40.406267',
    lineYOffset: 3,
    hasTail: true,
  },
  o: {
    arrows:
      'm 29.650095,16.843626 -1.083763,-0.305903 -0.09192,0.289212 -0.827328,-0.697246 1.099345,-0.170732 -0.09192,0.289212 1.087504,0.306234 z',
    lines: 'M 12.191164,38.610711 H 40.339786',
    lineYOffset: 3,
    hasTail: false,
  },
  u: {
    arrows:
      'm 17.654441,16.08832 0.05533,1.124748 0.303426,-0.005 -0.39732,1.00636 -0.512091,-0.987659 0.303426,-0.005 -0.05621,-1.128399 z',
    lines: 'M 12.175015,38.15092 H 40.323637',
    lineYOffset: 3,
    hasTail: false,
  },
  l: {
    arrows:
      'm 24.509191,9.6295033 0.01929,1.1259417 0.303431,0.0047 -0.429338,0.993123 -0.480204,-1.00355 0.303431,0.0047 -0.02005,-1.1296197 z',
    lines: 'M 12.459485,44.713225 H 40.608107',
    lineYOffset: 3,
    hasTail: false,
  },
  f: {
    arrows:
      'M 35.017208,3.0799583 33.8977,2.9582286 l -0.04262,0.3004585 -0.931605,-0.5502155 1.055744,-0.3508755 -0.04262,0.3004585 1.123252,0.121436 z',
    lines: 'M 12.425776,51.900035 H 40.574398',
    lineYOffset: 3,
    hasTail: true,
  },
  b: {
    arrows:
      'm 18.61136,9.353422 0.01929,1.125942 0.303431,0.0047 -0.429338,0.993123 -0.480204,-1.00355 0.303431,0.0047 -0.02005,-1.12962 z',
    lines: 'M 12.462408,44.750885 H 40.61103',
    lineYOffset: 3,
    hasTail: false,
  },
  j: {
    arrows:
      'm 31.0261,13.487503 0.01929,1.125942 0.303431,0.0047 -0.429338,0.993123 -0.480204,-1.00355 0.303431,0.0047 -0.02005,-1.12962 z',
    lines: 'M 12.462408,50.042555 H 40.61103',
    lineYOffset: 3,
    hasTail: true,
  },
  v: {
    arrows:
      'm 18.554085,16.23304 0.356566,1.068166 0.290833,-0.08665 -0.111244,1.076221 -0.759441,-0.812994 0.290834,-0.08665 -0.358396,-1.071446 z',
    lines: 'M 12.443293,38.149378 H 40.591915',
    lineYOffset: 3,
    hasTail: false,
  },
  w: {
    arrows:
      'm 12.88394,16.206983 0.348731,1.07075 0.291459,-0.08452 -0.119126,1.075377 -0.753463,-0.818536 0.29146,-0.08452 -0.350537,-1.074042 z',
    lines: 'M 12.443293,38.149378 H 40.591915',
    lineYOffset: 3,
    hasTail: false,
  },
  z: {
    arrows:
      'm 19.749671,16.626539 1.126013,-0.01467 0.0059,-0.303408 0.991351,0.433417 -1.005514,0.476076 0.0059,-0.303409 -1.129693,0.01541 z',
    lines: 'M 12.369481,37.908346 H 40.518103',
    lineYOffset: 3,
    hasTail: false,
  },
  y: {
    arrows:
      'm 19.6837,8.7823605 0.100569,1.1216091 0.302972,-0.017273 -0.356491,1.0215384 -0.551429,-0.9662467 0.302973,-0.017273 -0.101582,-1.125222 z',
    lines: 'M 12.384774,30.834516 H 40.533396',
    lineYOffset: 3,
    hasTail: true,
  },
  k: {
    arrows:
      'm 19.13046,9.4116952 0.01929,1.1259418 0.303431,0.0047 -0.429338,0.993123 -0.480204,-1.00355 0.303431,0.0047 -0.02005,-1.1296198 z',
    lines: 'M 12.453224,44.333259 H 40.601846',
    lineYOffset: 3,
    hasTail: false,
  },
  ck: {
    arrows:
      'm 29.717242,9.7987265 0.01929,1.1259415 0.303431,0.0047 -0.429338,0.993123 -0.480204,-1.00355 0.303431,0.0047 -0.02005,-1.1296195 z m -8.235443,13.9355505 -1.062876,-0.372038 -0.109546,0.283006 -0.782838,-0.746853 1.10777,-0.102732 -0.109546,0.283006 1.06659,0.372598 z',
    lines: 'M 5.5746095,44.217973 H 47.476441',
    lineYOffset: 3,
    hasTail: false,
  },
  qu: {
    arrows:
      'm 30.45992,9.2880601 0.01929,1.1259419 0.303431,0.0047 -0.429338,0.993123 -0.480204,-1.00355 0.303431,0.0047 -0.02005,-1.1296199 z m -11.301315,0.7347609 -1.062876,-0.3720379 -0.109546,0.283006 -0.782838,-0.746853 1.10777,-0.102732 -0.109546,0.283006 1.06659,0.372598 z',
    lines: 'M 2.0087989,31.168953 H 50.981717',
    lineYOffset: 3,
    hasTail: true,
  },
  x: {
    arrows:
      'm 20.48782,16.117655 0.622979,0.938092 0.258138,-0.159553 0.173483,1.067958 -0.945296,-0.586622 0.25814,-0.159551 -0.625602,-0.94078 z',
    lines: 'M 12.436949,37.904385 H 40.585571',
    lineYOffset: 3,
    hasTail: false,
  },

  sh: {
    arrows: '',
    lines: '',
    lineYOffset: 3,
    hasTail: false,
  },
  ch: {
    arrows: '',
    lines: '',
    lineYOffset: 3,
    hasTail: false,
  },
  th: {
    arrows: '',
    lines: '',
    lineYOffset: 3,
    hasTail: false,
  },
  ng: {
    arrows: '',
    lines: '',
    lineYOffset: 3,
    hasTail: true,
  },
  ai: {
    arrows: '',
    lines: '',
    lineYOffset: 3,
    hasTail: false,
  },
  ee: {
    arrows: '',
    lines: '',
    lineYOffset: 3,
    hasTail: false,
  },
  ie: {
    arrows: '',
    lines: '',
    lineYOffset: 3,
    hasTail: false,
  },
  oa: {
    arrows: '',
    lines: '',
    lineYOffset: 3,
    hasTail: false,
  },
  ue: {
    arrows: '',
    lines: '',
    lineYOffset: 3,
    hasTail: false,
  },
  ar: {
    arrows: '',
    lines: '',
    lineYOffset: 3,
    hasTail: false,
  },
  er: {
    arrows: '',
    lines: '',
    lineYOffset: 3,
    hasTail: false,
  },
  or: {
    arrows: '',
    lines: '',
    lineYOffset: 3,
    hasTail: false,
  },
  oi: {
    arrows: '',
    lines: '',
    lineYOffset: 3,
    hasTail: false,
  },
  ou: {
    arrows: '',
    lines: '',
    lineYOffset: 3,
    hasTail: false,
  },
  oo: {
    arrows: '',
    lines: '',
    lineYOffset: 3,
    hasTail: false,
  },
  air: {
    arrows: '',
    lines: '',
    lineYOffset: 3,
    hasTail: false,
  },
  ear: {
    arrows: '',
    lines: '',
    lineYOffset: 3,
    hasTail: false,
  },
  ure: {
    arrows: '',
    lines: '',
    lineYOffset: 3,
    hasTail: false,
  },
};

export const getSoundExtraData = (soundName: SoundName): SoundExtraData =>
  soundsExtraData[soundName] || {
    arrows: undefined,
    lines: undefined,
    lineYOffset: 0,
    hasTail: false,
  };
